import Envoy from "../util/Envoy";
import { UploadFile } from "antd";
import { RcFile } from "antd/es/upload";

class BatchProvider extends Envoy {
  public async migrateData(files: {
    userFile: UploadFile;
    dimensionFile: UploadFile;
    categoryDimensionFile: UploadFile;
    categoryFile: UploadFile;
    challengeFile: UploadFile;
    stageFile: UploadFile;
    ideaFile: UploadFile;
  }): Promise<number> {
    try {
      const formData = new FormData();
      for (const [key, file] of Object.entries(files)) {
        console.log(key, file);
        if (file) {
          const fileData = await this.convertUploadFileToFormData(file);
          formData.append(key, fileData.get("file") as Blob);
        }
      }

      const response = await this.conn.post("/migrate", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.messages?.length) {
        throw new Error(response.data.messages.join("\n"));
      }

      return response.data.data;
    } catch (error) {
      console.error("Erro ao migrar dados:", error);
      throw error;
    }
  }

  public async getBatchStatus(batchId: number): Promise<string> {
    try {
      const response = await this.conn.get(`/migrate/status/${batchId}`);
      return response.data.data;
    } catch (error) {
      console.error("Erro ao obter status do lote:", error);
      throw error;
    }
  }

  private async convertUploadFileToFormData(uploadFile: UploadFile): Promise<FormData> {
    const formData = new FormData();
console.log({uploadFile});
    if (uploadFile.originFileObj) {
      const file = uploadFile.originFileObj as RcFile;
      formData.append("file", file, file.name);
    } else if (uploadFile.url) {
      const response = await fetch(uploadFile.url);
      const blob = await response.blob();
      formData.append("file", blob, uploadFile.name);
    } else {
      console.log("O arquivo não é válido ou não foi encontrado.");
    }

    return formData;
  }
}

export default BatchProvider;
